angular.module('zc.projects')

.directive 'zcCampaignMomentGraph', ($q, $translate, CampaignStats, Chart) ->
    restrict: 'E'
    require: '?filters'
    scope:
      project : '='
      campaign: '='
      filters : '='
    templateUrl: '/templates/projects.campaigns/views/directives/campaign_moment_graph.html'

    controller: ($scope) ->
      createPaths = ->
        apikey: $scope.campaign.apikey
        dimension: 'hourly'

      createQuery = ->
        match:
          campaign_id: $scope.campaign.id
          start_at:
            $gte: new Date($scope.filters.start_at)
            $lt: new Date($scope.filters.end_at)
        pipeline: [
          $group:
            _id:
              from: "$from"
              to: "$to"
            count:
              $sum: "$count"
        ,
          $project:
            from: "$_id.from"
            to: "$_id.to"
            count: "$count"
        ,
          $sort:
            from: 1
        ]

      updateCampaignDwellData = (paths, query) ->
        CampaignStats.getHourlyDwellDistribution paths, query
        .then (res) ->
          $scope.campaignDwellConfig = Chart.getChartConfig('campaignDwell')
          Chart.addSeries $scope.campaignDwellConfig,
            name: $translate.instant('projectsCampaigns.directives.campaignMomentGraph.sessionCount')
            data: ([i.from, i.count] for i in res)

      updateHistoryCountData = (paths, query) ->
        CampaignStats.getHourlyHistoryCountDistribution paths, query
        .then (res) ->
          $scope.campaignHistoryCountConfig = Chart.getChartConfig('campaignHistoryCount')
          Chart.addSeries $scope.campaignHistoryCountConfig,
            name: $translate.instant('projectsCampaigns.directives.campaignMomentGraph.sessionCount')
            data: ([i.from, i.count] for i in res)

      updateData = ->
        paths = createPaths()
        query = createQuery()
        updateCampaignDwellData paths, query
        updateHistoryCountData paths, query

      $scope.$watch('filters', updateData, true)



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/campaign_moment_graph.coffee